import { render, staticRenderFns } from "./Palveluhakemus.vue?vue&type=template&id=b1a4a3c2&scoped=true&"
import script from "./Palveluhakemus.vue?vue&type=script&lang=js&"
export * from "./Palveluhakemus.vue?vue&type=script&lang=js&"
import style0 from "./Palveluhakemus.vue?vue&type=style&index=0&id=b1a4a3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a4a3c2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VCol,VDivider,VRow,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1a4a3c2')) {
      api.createRecord('b1a4a3c2', component.options)
    } else {
      api.reload('b1a4a3c2', component.options)
    }
    module.hot.accept("./Palveluhakemus.vue?vue&type=template&id=b1a4a3c2&scoped=true&", function () {
      api.rerender('b1a4a3c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Palveluhakemus.vue"
export default component.exports